import KatalLogger, { Level, LoggerConfig } from '@amzn/katal-logger';

import { ProvisionedConstants } from './constants';

const isDev: boolean = ProvisionedConstants.STAGE === 'Dev';

const katalLoggerConfig: LoggerConfig = {
  url: ProvisionedConstants.KATAL_LOGGER_URL,
  logThreshold: isDev ? Level.DEBUG : Level.INFO,
  maxLogLineSize: 10000,
  logToConsole: isDev,
  recordMetrics: false,
};

export const logger = new KatalLogger(katalLoggerConfig);
logger.addErrorListener();
